import React from 'react';

import BlockContent from '~/components/layouts/block-content';
import Modal from '~/components/modals/modal';

import styles from '~/components/modals/terms-conditions/terms-conditions-modal.module.scss';

const TermsConditionsModal = ({ onClose, isOpen, content }) => (
  <Modal onClose={onClose} isOpen={isOpen}>
    <Content content={content} />
  </Modal>
);

const Content = ({ content }) => (
  <div className={styles.termsModal}>
    <h2>Terms and Conditions</h2>
    <div className={styles.contentWrapper}>
      <BlockContent content={content} />
    </div>
  </div>
);

export default TermsConditionsModal;
